import type { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd'

import { F0Box, F0Icon, F0Text } from '@factorialco/f0-react'
import { Dropdown, Switch, type DropdownItem } from '@factorialco/f0-react/dist/experimental'
import { Delete, Ellipsis, Handle, Pencil } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import type { MergedField } from './types'

type Props = {
  field: MergedField
  dragHandleProps?: DraggableProvidedDragHandleProps | null
  onToggleVisibility: (fieldKey: string, newVisible: boolean) => void
  onEdit: (field: MergedField) => void
  onDelete: (fieldKey: string) => void
}

function SectionField({ field, dragHandleProps, onToggleVisibility, onEdit, onDelete }: Props) {
  const fieldActions: DropdownItem[] = [
    {
      label: i18n.t('common.edit'),
      icon: Pencil,
      onClick: () => onEdit(field),
    },
    {
      label: i18n.t('common.delete'),
      icon: Delete,
      critical: true,
      onClick: () => onDelete(field.key),
    },
  ]

  return (
    <F0Box display="flex" alignItems="center" justifyContent="between" paddingX="md" paddingY="sm">
      <F0Box display="flex" flexDirection="row" alignItems="center" gap="sm">
        {dragHandleProps && (
          <F0Box
            {...dragHandleProps}
            display="inline-flex"
            data-testid={`field-drag-handle-${field.key}`}
            aria-label={i18n.t(
              'procurement.purchase_requests.settings.po_templates.detail.reorder_field'
            )}
          >
            <F0Icon icon={Handle} size="xs" color="secondary" />
          </F0Box>
        )}
        <F0Text content={field.displayLabel} variant="body" />
      </F0Box>
      <F0Box display="flex" flexDirection="row" alignItems="center" gap="sm">
        <Switch
          checked={field.visible}
          onCheckedChange={(checked) => onToggleVisibility(field.key, checked)}
          title={field.displayLabel}
          hideLabel
        />
        {!field.predefined && (
          <Dropdown
            items={fieldActions}
            icon={Ellipsis}
            size="sm"
            data-testid={`field-actions-${field.key}`}
          />
        )}
      </F0Box>
    </F0Box>
  )
}

export default SectionField
